export {
  findNearestModelViewerAspectRatio,
  resolveModelViewerAspectRatio
} from './resolveModelViewerAspectRatio';
